// commonActions.js
import showToast from '../../utils/toast';
import { changeEmployerSubscriptionService, createSubscriptionPlanService, deleteSubscriptionPlanService, getAccountManagersService, getAdminNotificationsBadgeService, getAdminNotificationsListService, getDashboardAppSummaryDataService, getDashboardJobApplicationMonthlySummaryService, getDashboardMoMTrendsService, getDashboardPipelineMonthlySummaryService, getDashboardPipelineService, getDashboardManagerSummaryDataService, getDashboardSummaryDataService, getNotificationsService, getNotificationUsersService, getSubscriptionPlansService, markAdminNotificationItemAsReadService, markAdminNotificationsAsReadService, patchSubscriptionPlanService, setCompanyGoalService, setManagerGoalService, updateCompanyGoalService, updateManagerGoalService, getCommercialTermsService, createCommercialTermsService, patchCommercialTermsService, deleteCommercialTermsService, getDashboardMonthlyTrendsService, getDashboardPendingDetailsCandidatesService } from '../service/commonService';
import { startLoader, stopLoader } from './loaderActions';

export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';

export const GET_NOTIFICATION_USERS = 'GET_NOTIFICATION_USERS';
export const GET_NOTIFICATION_USERS_SUCCESS = 'GET_NOTIFICATION_USERS_SUCCESS';
export const GET_NOTIFICATION_USERS_FAILURE = 'GET_NOTIFICATION_USERS_FAILURE';

export const GET_ADMIN_NOTIFICATIONS = 'GET_ADMIN_NOTIFICATIONS';
export const GET_ADMIN_NOTIFICATIONS_SUCCESS = 'GET_ADMIN_NOTIFICATIONS_SUCCESS';
export const GET_ADMIN_NOTIFICATIONS_FAILURE = 'GET_ADMIN_NOTIFICATIONS_FAILURE';

export const MARK_ADMIN_NOTIFICATIONS_AS_READ = 'MARK_ADMIN_NOTIFICATIONS_AS_READ';
export const MARK_ADMIN_NOTIFICATIONS_AS_READ_SUCCESS = 'MARK_ADMIN_NOTIFICATIONS_AS_READ_SUCCESS';
export const MARK_ADMIN_NOTIFICATIONS_AS_READ_FAILURE = 'MARK_ADMIN_NOTIFICATIONS_AS_READ_FAILURE';

export const MARK_ADMIN_NOTIFICATION_ITEM_AS_READ = 'MARK_ADMIN_NOTIFICATION_ITEM_AS_READ';
export const MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_SUCCESS = 'MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_SUCCESS';
export const MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_FAILURE = 'MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_FAILURE';

export const GET_ADMIN_NOTIFICATIONS_BADGE = 'GET_ADMIN_NOTIFICATIONS_BADGE';
export const GET_ADMIN_NOTIFICATIONS_BADGE_SUCCESS = 'GET_ADMIN_NOTIFICATIONS_BADGE_SUCCESS';
export const GET_ADMIN_NOTIFICATIONS_BADGE_FAILURE = 'GET_ADMIN_NOTIFICATIONS_BADGE_FAILURE';

export const GET_SUBSCRIPTION_PLANS = 'GET_SUBSCRIPTION_PLANS';
export const GET_SUBSCRIPTION_PLANS_SUCCESS = 'GET_SUBSCRIPTION_PLANS_SUCCESS';
export const GET_SUBSCRIPTION_PLANS_FAILURE = 'GET_SUBSCRIPTION_PLANS_FAILURE';

export const ADD_SUBSCRIPTION_PLAN = 'ADD_SUBSCRIPTION_PLAN';
export const ADD_SUBSCRIPTION_PLAN_SUCCESS = 'ADD_SUBSCRIPTION_PLAN_SUCCESS';
export const ADD_SUBSCRIPTION_PLAN_FAILURE = 'ADD_SUBSCRIPTION_PLAN_FAILURE';

export const EDIT_SUBSCRIPTION_PLAN = 'EDIT_SUBSCRIPTION_PLAN';
export const EDIT_SUBSCRIPTION_PLAN_SUCCESS = 'EDIT_SUBSCRIPTION_PLAN_SUCCESS';
export const EDIT_SUBSCRIPTION_PLAN_FAILURE = 'EDIT_SUBSCRIPTION_PLAN_FAILURE';

export const DELETE_SUBSCRIPTION_PLAN = 'DELETE_SUBSCRIPTION_PLAN';
export const DELETE_SUBSCRIPTION_PLAN_SUCCESS = 'DELETE_SUBSCRIPTION_PLAN_SUCCESS';
export const DELETE_SUBSCRIPTION_PLAN_FAILURE = 'DELETE_SUBSCRIPTION_PLAN_FAILURE';

export const CHANGE_EMPLOYER_SUBSCRIPTION = 'CHANGE_EMPLOYER_SUBSCRIPTION';
export const CHANGE_EMPLOYER_SUBSCRIPTION_SUCCESS = 'CHANGE_EMPLOYER_SUBSCRIPTION_SUCCESS';
export const CHANGE_EMPLOYER_SUBSCRIPTION_FAILURE = 'CHANGE_EMPLOYER_SUBSCRIPTION_FAILURE';

export const GET_COMMERCIAL_TERMS = 'GET_COMMERCIAL_TERMS';
export const GET_COMMERCIAL_TERMS_SUCCESS = 'GET_COMMERCIAL_TERMS_SUCCESS';
export const GET_COMMERCIAL_TERMS_FAILURE = 'GET_COMMERCIAL_TERMS_FAILURE';

export const ADD_COMMERCIAL_TERMS = 'ADD_COMMERCIAL_TERMS';
export const ADD_COMMERCIAL_TERMS_SUCCESS = 'ADD_COMMERCIAL_TERMS_SUCCESS';
export const ADD_COMMERCIAL_TERMS_FAILURE = 'ADD_COMMERCIAL_TERMS_FAILURE';

export const EDIT_COMMERCIAL_TERMS = 'EDIT_COMMERCIAL_TERMS';
export const EDIT_COMMERCIAL_TERMS_SUCCESS = 'EDIT_COMMERCIAL_TERMS_SUCCESS';
export const EDIT_COMMERCIAL_TERMS_FAILURE = 'EDIT_COMMERCIAL_TERMS_FAILURE';

export const DELETE_COMMERCIAL_TERMS = 'DELETE_COMMERCIAL_TERMS';
export const DELETE_COMMERCIAL_TERMS_SUCCESS = 'DELETE_COMMERCIAL_TERMS_SUCCESS';
export const DELETE_COMMERCIAL_TERMS_FAILURE = 'DELETE_COMMERCIAL_TERMS_FAILURE';

export const CHANGE_EMPLOYER_COMMERCIAL_TERMS = 'CHANGE_EMPLOYER_COMMERCIAL_TERMS';
export const CHANGE_EMPLOYER_COMMERCIAL_TERMS_SUCCESS = 'CHANGE_EMPLOYER_COMMERCIAL_TERMS_SUCCESS';
export const CHANGE_EMPLOYER_COMMERCIAL_TERMS_FAILURE = 'CHANGE_EMPLOYER_COMMERCIAL_TERMS_FAILURE';

export const GET_DASHBOARD_SUMMARY = 'GET_DASHBOARD_SUMMARY';
export const GET_DASHBOARD_SUMMARY_SUCCESS = 'GET_DASHBOARD_SUMMARY_SUCCESS';
export const GET_DASHBOARD_SUMMARY_FAILURE = 'GET_DASHBOARD_SUMMARY_FAILURE';

export const GET_DASHBOARD_APP_SUMMARY = 'GET_DASHBOARD_APP_SUMMARY';
export const GET_DASHBOARD_APP_SUMMARY_SUCCESS = 'GET_DASHBOARD_APP_SUMMARY_SUCCESS';
export const GET_DASHBOARD_APP_SUMMARY_FAILURE = 'GET_DASHBOARD_APP_SUMMARY_FAILURE';

export const GET_DASHBOARD_MANAGER_SUMMARY = 'GET_DASHBOARD_MANAGER_SUMMARY';
export const GET_DASHBOARD_MANAGER_SUMMARY_SUCCESS = 'GET_DASHBOARD_MANAGER_SUMMARY_SUCCESS';
export const GET_DASHBOARD_MANAGER_SUMMARY_FAILURE = 'GET_DASHBOARD_MANAGER_SUMMARY_FAILURE';

export const GET_DASHBOARD_PIPELINE = 'GET_DASHBOARD_PIPELINE';
export const GET_DASHBOARD_PIPELINE_SUCCESS = 'GET_DASHBOARD_PIPELINE_SUCCESS';
export const GET_DASHBOARD_PIPELINE_FAILURE = 'GET_DASHBOARD_PIPELINE_FAILURE';

export const GET_DASHBOARD_PENDING_DETAILS_CANDIDATES = 'GET_DASHBOARD_PENDING_DETAILS_CANDIDATES';
export const GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_SUCCESS = 'GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_SUCCESS';
export const GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_FAILURE = 'GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_FAILURE';

export const GET_ACCOUNT_MANAGERS = 'GET_ACCOUNT_MANAGERS';
export const GET_ACCOUNT_MANAGERS_SUCCESS = 'GET_ACCOUNT_MANAGERS_SUCCESS';
export const GET_ACCOUNT_MANAGERS_FAILURE = 'GET_ACCOUNT_MANAGERS_FAILURE';

export const GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY = 'GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY';
export const GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_SUCCESS = 'GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_SUCCESS';
export const GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_FAILURE = 'GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_FAILURE';

export const GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY = 'GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY';
export const GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_SUCCESS = 'GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_SUCCESS';
export const GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_FAILURE = 'GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_FAILURE';

export const GET_DASHBOARD_MOM_TRENDS = 'GET_DASHBOARD_MOM_TRENDS';
export const GET_DASHBOARD_MOM_TRENDS_SUCCESS = 'GET_DASHBOARD_MOM_TRENDS_SUCCESS';
export const GET_DASHBOARD_MOM_TRENDS_FAILURE = 'GET_DASHBOARD_MOM_TRENDS_FAILURE';

export const GET_DASHBOARD_MONTHLY_TRENDS = 'GET_DASHBOARD_MONTHLY_TRENDS';
export const GET_DASHBOARD_MONTHLY_TRENDS_SUCCESS = 'GET_DASHBOARD_MONTHLY_TRENDS_SUCCESS';
export const GET_DASHBOARD_MONTHLY_TRENDS_FAILURE = 'GET_DASHBOARD_MONTHLY_TRENDS_FAILURE';

export const SET_DASHBOARD_TIME_PERIOD = 'SET_DASHBOARD_TIME_PERIOD';

export const SET_ACTIVE_MANAGER = 'SET_ACTIVE_MANAGER';

export const SET_COMPANY_GOAL = 'SET_COMPANY_GOAL';
export const SET_COMPANY_GOAL_SUCCESS = 'SET_COMPANY_GOAL_SUCCESS';
export const SET_COMPANY_GOAL_FAILURE = 'SET_COMPANY_GOAL_FAILURE';

export const EDIT_COMPANY_GOAL = 'EDIT_COMPANY_GOAL';
export const EDIT_COMPANY_GOAL_SUCCESS = 'EDIT_COMPANY_GOAL_SUCCESS';
export const EDIT_COMPANY_GOAL_FAILURE = 'EDIT_COMPANY_GOAL_FAILURE';

export const SET_MANAGER_GOAL = 'SET_MANAGER_GOAL';
export const SET_MANAGER_GOAL_SUCCESS = 'SET_MANAGER_GOAL_SUCCESS';
export const SET_MANAGER_GOAL_FAILURE = 'SET_MANAGER_GOAL_FAILURE';

export const EDIT_MANAGER_GOAL = 'EDIT_MANAGER_GOAL';
export const EDIT_MANAGER_GOAL_SUCCESS = 'EDIT_MANAGER_GOAL_SUCCESS';
export const EDIT_MANAGER_GOAL_FAILURE = 'EDIT_MANAGER_GOAL_FAILURE';

export const getNotifications = () => ({
  type: GET_NOTIFICATIONS,
});

export const getNotificationsSuccess = (response) => ({
  type: GET_NOTIFICATIONS_SUCCESS,
  payload: response,
});

export const getNotificationsFailure = (error) => ({
  type: GET_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const getNotificationUsers = () => ({
  type: GET_NOTIFICATION_USERS,
});

export const getNotificationUsersSuccess = (response) => ({
  type: GET_NOTIFICATION_USERS_SUCCESS,
  payload: response,
});

export const getNotificationUsersFailure = (error) => ({
  type: GET_NOTIFICATION_USERS_FAILURE,
  payload: error,
});

export const getAdminNotifications = () => ({
  type: GET_ADMIN_NOTIFICATIONS,
});

export const getAdminNotificationsSuccess = (response) => ({
  type: GET_ADMIN_NOTIFICATIONS_SUCCESS,
  payload: response,
});

export const getAdminNotificationsFailure = (error) => ({
  type: GET_ADMIN_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const markAdminNotificationsAsRead = () => ({
  type: MARK_ADMIN_NOTIFICATIONS_AS_READ,
});

export const markAdminNotificationsAsReadSuccess = (response) => ({
  type: MARK_ADMIN_NOTIFICATIONS_AS_READ_SUCCESS,
  payload: response,
});

export const markAdminNotificationsAsReadFailure = (error) => ({
  type: MARK_ADMIN_NOTIFICATIONS_AS_READ_FAILURE,
  payload: error,
});

export const markAdminNotificationItemAsRead = () => ({
  type: MARK_ADMIN_NOTIFICATION_ITEM_AS_READ,
});

export const markAdminNotificationItemAsReadSuccess = (response) => ({
  type: MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_SUCCESS,
  payload: response,
});

export const markAdminNotificationItemAsReadFailure = (error) => ({
  type: MARK_ADMIN_NOTIFICATION_ITEM_AS_READ_FAILURE,
  payload: error,
});

export const getAdminNotificationsBadge = () => ({
  type: GET_ADMIN_NOTIFICATIONS_BADGE,
});

export const getAdminNotificationsBadgeSuccess = (response) => ({
  type: GET_ADMIN_NOTIFICATIONS_BADGE_SUCCESS,
  payload: response,
});

export const getAdminNotificationsBadgeFailure = (error) => ({
  type: GET_ADMIN_NOTIFICATIONS_BADGE_FAILURE,
  payload: error,
});


export const getSubscriptionPlans = () => ({
  type: GET_SUBSCRIPTION_PLANS,
});

export const getSubscriptionPlansSuccess = (response) => ({
  type: GET_SUBSCRIPTION_PLANS_SUCCESS,
  payload: response,
});

export const getSubscriptionPlansFailure = (error) => ({
  type: GET_SUBSCRIPTION_PLANS_FAILURE,
  payload: error,
});

export const addSubscriptionPlan = () => ({
  type: ADD_SUBSCRIPTION_PLAN,
});

export const addSubscriptionPlanSuccess = (response) => ({
  type: ADD_SUBSCRIPTION_PLAN_SUCCESS,
  payload: response,
});

export const addSubscriptionPlanFailure = (error) => ({
  type: ADD_SUBSCRIPTION_PLAN_FAILURE,
  payload: error,
});

export const editSubscriptionPlan = () => ({
  type: EDIT_SUBSCRIPTION_PLAN,
});

export const editSubscriptionPlanSuccess = (response) => ({
  type: EDIT_SUBSCRIPTION_PLAN_SUCCESS,
  payload: response,
});

export const editSubscriptionPlanFailure = (error) => ({
  type: EDIT_SUBSCRIPTION_PLAN_FAILURE,
  payload: error,
});

export const deleteSubscriptionPlan = () => ({
  type: DELETE_SUBSCRIPTION_PLAN,
});

export const deleteSubscriptionPlanSuccess = (response) => ({
  type: DELETE_SUBSCRIPTION_PLAN_SUCCESS,
  payload: response,
});

export const deleteSubscriptionPlanFailure = (error) => ({
  type: DELETE_SUBSCRIPTION_PLAN_FAILURE,
  payload: error,
});

export const changeEmployerSubscription = () => ({
  type: CHANGE_EMPLOYER_SUBSCRIPTION,
});

export const changeEmployerSubscriptionSuccess = (response) => ({
  type: CHANGE_EMPLOYER_SUBSCRIPTION_SUCCESS,
  payload: response,
});

export const changeEmployerSubscriptionFailure = (error) => ({
  type: CHANGE_EMPLOYER_SUBSCRIPTION_FAILURE,
  payload: error,
});

export const getCommercialTerms = () => ({
  type: GET_COMMERCIAL_TERMS,
});

export const getCommercialTermsSuccess = (response) => ({
  type: GET_COMMERCIAL_TERMS_SUCCESS,
  payload: response,
});

export const getCommercialTermsFailure = (error) => ({
  type: GET_COMMERCIAL_TERMS_FAILURE,
  payload: error,
});

export const addCommercialTerms = () => ({
  type: ADD_COMMERCIAL_TERMS,
});

export const addCommercialTermsSuccess = (response) => ({
  type: ADD_COMMERCIAL_TERMS_SUCCESS,
  payload: response,
});

export const addCommercialTermsFailure = (error) => ({
  type: ADD_COMMERCIAL_TERMS_FAILURE,
  payload: error,
});

export const editCommercialTerms = () => ({
  type: EDIT_COMMERCIAL_TERMS,
});

export const editCommercialTermsuccess = (response) => ({
  type: EDIT_COMMERCIAL_TERMS_SUCCESS,
  payload: response,
});

export const editCommercialTermsFailure = (error) => ({
  type: EDIT_COMMERCIAL_TERMS_FAILURE,
  payload: error,
});

export const deleteCommercialTerms = () => ({
  type: DELETE_COMMERCIAL_TERMS,
});

export const deleteCommercialTermsSuccess = (response) => ({
  type: DELETE_COMMERCIAL_TERMS_SUCCESS,
  payload: response,
});

export const deleteCommercialTermsFailure = (error) => ({
  type: DELETE_COMMERCIAL_TERMS_FAILURE,
  payload: error,
});

export const changeEmployerCommercialTerms = () => ({
  type: CHANGE_EMPLOYER_COMMERCIAL_TERMS,
});

export const changeEmployerCommercialTermsSuccess = (response) => ({
  type: CHANGE_EMPLOYER_COMMERCIAL_TERMS_SUCCESS,
  payload: response,
});

export const changeEmployerCommercialTermsFailure = (error) => ({
  type: CHANGE_EMPLOYER_COMMERCIAL_TERMS_FAILURE,
  payload: error,
});

export const getDashboardSummary = () => ({
  type: GET_DASHBOARD_SUMMARY,
});

export const getDashboardSummarySuccess = (response) => ({
  type: GET_DASHBOARD_SUMMARY_SUCCESS,
  payload: response,
});

export const getDashboardSummaryFailure = (error) => ({
  type: GET_DASHBOARD_SUMMARY_FAILURE,
  payload: error,
});

export const getDashboardAppSummary = () => ({
  type: GET_DASHBOARD_APP_SUMMARY,
});

export const getDashboardAppSummarySuccess = (response) => ({
  type: GET_DASHBOARD_APP_SUMMARY_SUCCESS,
  payload: response,
});

export const getDashboardAppSummaryFailure = (error) => ({
  type: GET_DASHBOARD_APP_SUMMARY_FAILURE,
  payload: error,
});

export const getDashboardManagerSummary = () => ({
  type: GET_DASHBOARD_MANAGER_SUMMARY,
});

export const getDashboardManagerSummarySuccess = (response) => ({
  type: GET_DASHBOARD_MANAGER_SUMMARY_SUCCESS,
  payload: response,
});

export const getDashboardManagerSummaryFailure = (error) => ({
  type: GET_DASHBOARD_MANAGER_SUMMARY_FAILURE,
  payload: error,
});

export const getDashboardPipeline = () => ({
  type: GET_DASHBOARD_PIPELINE,
});

export const getDashboardPipelineSuccess = (response) => ({
  type: GET_DASHBOARD_PIPELINE_SUCCESS,
  payload: response,
});

export const getDashboardPipelineFailure = (error) => ({
  type: GET_DASHBOARD_PIPELINE_FAILURE,
  payload: error,
});

export const getDashboardPendingDetailsCandidates = () => ({
  type: GET_DASHBOARD_PENDING_DETAILS_CANDIDATES,
});

export const getDashboardPendingDetailsCandidatesSuccess = (response) => ({
  type: GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_SUCCESS,
  payload: response,
});

export const getDashboardPendingDetailsCandidatesFailure = (error) => ({
  type: GET_DASHBOARD_PENDING_DETAILS_CANDIDATES_FAILURE,
  payload: error,
});

export const getAccountManagers = () => ({
  type: GET_ACCOUNT_MANAGERS,
});

export const getAccountManagersSuccess = (response) => ({
  type: GET_ACCOUNT_MANAGERS_SUCCESS,
  payload: response,
});

export const getAccountManagersFailure = (error) => ({
  type: GET_ACCOUNT_MANAGERS_FAILURE,
  payload: error,
});

export const getDashboardJobApplicationMonthlySummary = () => ({
  type: GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY,
});

export const getDashboardJobApplicationMonthlySummarySuccess = (response) => ({
  type: GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_SUCCESS,
  payload: response,
});

export const getDashboardJobApplicationMonthlySummaryFailure = (error) => ({
  type: GET_DASHBOARD_JOB_APPLICATION_MONTHLY_SUMMARY_FAILURE,
  payload: error,
});

export const getDashboardPipelineMonthlySummary = () => ({
  type: GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY,
});

export const getDashboardPipelineMonthlySummarySuccess = (response) => ({
  type: GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_SUCCESS,
  payload: response,
});

export const getDashboardPipelineMonthlySummaryFailure = (error) => ({
  type: GET_DASHBOARD_PIPELINE_MONTHLY_SUMMARY_FAILURE,
  payload: error,
});

export const getDashboardMoMTrends = () => ({
  type: GET_DASHBOARD_MOM_TRENDS,
});

export const getDashboardMoMTrendsSuccess = (response) => ({
  type: GET_DASHBOARD_MOM_TRENDS_SUCCESS,
  payload: response,
});

export const getDashboardMoMTrendsFailure = (error) => ({
  type: GET_DASHBOARD_MOM_TRENDS_FAILURE,
  payload: error,
});

export const getDashboardMonthlyTrends = () => ({
  type: GET_DASHBOARD_MONTHLY_TRENDS,
});

export const getDashboardMonthlyTrendsSuccess = (response) => ({
  type: GET_DASHBOARD_MONTHLY_TRENDS_SUCCESS,
  payload: response,
});

export const getDashboardMonthlyTrendsFailure = (error) => ({
  type: GET_DASHBOARD_MONTHLY_TRENDS_FAILURE,
  payload: error,
});

export const setDashboardTimePeriod = (response) => ({
  type: SET_DASHBOARD_TIME_PERIOD,
  payload: response,
});

export const setActiveManager = (response) => ({
  type: SET_ACTIVE_MANAGER,
  payload: response,
});

export const setCompanyGoal = () => ({
  type: SET_COMPANY_GOAL,
});

export const setCompanyGoalSuccess = (response) => ({
  type: SET_COMPANY_GOAL_SUCCESS,
  payload: response,
});

export const setCompanyGoalFailure = (error) => ({
  type: SET_COMPANY_GOAL_FAILURE,
  payload: error,
});

export const editCompanyGoal = () => ({
  type: EDIT_COMPANY_GOAL,
});

export const editCompanyGoalSuccess = (response) => ({
  type: EDIT_COMPANY_GOAL_SUCCESS,
  payload: response,
});

export const editCompanyGoalFailure = (error) => ({
  type: EDIT_COMPANY_GOAL_FAILURE,
  payload: error,
});

export const setManagerGoal = () => ({
  type: SET_MANAGER_GOAL,
});

export const setManagerGoalSuccess = (response) => ({
  type: SET_MANAGER_GOAL_SUCCESS,
  payload: response,
});

export const setManagerGoalFailure = (error) => ({
  type: SET_MANAGER_GOAL_FAILURE,
  payload: error,
});

export const editManagerGoal = () => ({
  type: EDIT_MANAGER_GOAL,
});

export const editManagerGoalSuccess = (response) => ({
  type: EDIT_MANAGER_GOAL_SUCCESS,
  payload: response,
});

export const editManagerGoalFailure = (error) => ({
  type: EDIT_MANAGER_GOAL_FAILURE,
  payload: error,
});

export const getNotificationsList = (payload) => async (dispatch) => {
  dispatch(getNotifications());
  dispatch(startLoader());

  try {
    const response = await getNotificationsService(payload);

    if (response.success) {
      dispatch(getNotificationsSuccess(response));
    } else {
      dispatch(getNotificationsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getNotificationsFailure('Error getting notification list'));
    showToast('Error getting notification list', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getNotificationUsersList = (notificationId, payload) => async (dispatch) => {
  dispatch(getNotificationUsers());
  dispatch(startLoader());

  try {
    const response = await getNotificationUsersService(notificationId, payload);

    if (response.success) {
      dispatch(getNotificationUsersSuccess(response));
    } else {
      dispatch(getNotificationUsersFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getNotificationUsersFailure('Error getting notification user list'));
    showToast('Error getting notification user list', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getAdminNotificationsList = (payload) => async (dispatch) => {
  dispatch(getAdminNotifications());
  dispatch(startLoader());

  try {
    const response = await getAdminNotificationsListService(payload);

    if (response.success) {
      dispatch(getAdminNotificationsSuccess(response));
    } else {
      dispatch(getAdminNotificationsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getAdminNotificationsFailure('Error getting admin notification list'));
    showToast('Error getting admin notification list', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const markAllAdminNotificationsAsRead = (adminUserId) => async (dispatch) => {
  dispatch(markAdminNotificationsAsRead());
  dispatch(startLoader());

  try {
    const response = await markAdminNotificationsAsReadService(adminUserId);

    if (response.success) {
      dispatch(markAdminNotificationsAsReadSuccess(true));
      let badgeParams = {
        'adminUserId': adminUserId
      }
      dispatch(getAdminNotificationsBadgeCount(badgeParams));
    } else {
      dispatch(markAdminNotificationsAsReadFailure(response.message));
    }
  } catch (error) {
    dispatch(markAdminNotificationsAsReadFailure('Error updating admin notification'));
  } finally {
    dispatch(stopLoader());
  }
};

export const markAdminNotificationAsRead = (adminNotificationId) => async (dispatch) => {
  dispatch(markAdminNotificationItemAsRead());
  dispatch(startLoader());

  try {
    const response = await markAdminNotificationItemAsReadService(adminNotificationId);

    if (response.success) {
      dispatch(markAdminNotificationItemAsReadSuccess(adminNotificationId));
    } else {
      dispatch(markAdminNotificationItemAsReadFailure(response.message));
    }
  } catch (error) {
    dispatch(markAdminNotificationItemAsReadFailure('Error updating admin notification'));
  } finally {
    dispatch(stopLoader());
  }
};

export const getAdminNotificationsBadgeCount = (payload) => async (dispatch) => {
  dispatch(getAdminNotificationsBadge());
  // dispatch(startLoader());

  try {
    const response = await getAdminNotificationsBadgeService(payload);

    if (response.success) {
      dispatch(getAdminNotificationsBadgeSuccess(response));
    } else {
      dispatch(getAdminNotificationsBadgeFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getAdminNotificationsBadgeFailure('Error getting admin notification badge'));
    showToast('Error getting admin notification badge', 'error');
  } finally {
    // dispatch(stopLoader());
  }
};

export const getSubscriptionPlansList = (payload) => async (dispatch) => {
  dispatch(getSubscriptionPlans());
  dispatch(startLoader());

  try {
    const response = await getSubscriptionPlansService(payload);

    if (response.success) {
      dispatch(getSubscriptionPlansSuccess(response));
    } else {
      dispatch(getSubscriptionPlansFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getSubscriptionPlansFailure('Error getting subscription plans list'));
    showToast('Error getting subscription plans list', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const createSubscriptionPlan = (payload) => async (dispatch) => {
  dispatch(addSubscriptionPlan());
  dispatch(startLoader());

  try {
    const response = await createSubscriptionPlanService(payload);
    if (response.success) {
      dispatch(addSubscriptionPlanSuccess(response.data));
      showToast(response.message, 'success')
    } else {
      dispatch(addSubscriptionPlanFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(addSubscriptionPlanFailure('Error creating subscription plan'));
    showToast('error creating subscription plan', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const updateSubscriptionPlan = (subscriptionPlanId, payload) => async (dispatch) => {
  dispatch(editSubscriptionPlan());
  dispatch(startLoader());

  try {
    const response = await patchSubscriptionPlanService(subscriptionPlanId, payload);

    if (response.success) {
      dispatch(editSubscriptionPlanSuccess(response.data));
      showToast(response.message, 'success')
    } else {
      dispatch(editSubscriptionPlanFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(editSubscriptionPlanFailure('Error editing subscription plan'));
    showToast('Error editing subscription plan', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const deleteSubscriptionPlanRecord = (subscriptionPlanId) => async (dispatch) => {
  dispatch(deleteSubscriptionPlan());
  dispatch(startLoader());

  try {
    const response = await deleteSubscriptionPlanService(subscriptionPlanId);
    if (response.success) {
      dispatch(deleteSubscriptionPlanSuccess(subscriptionPlanId));
      showToast(response.message, 'success')

    } else {
      dispatch(deleteSubscriptionPlanFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(deleteSubscriptionPlanFailure('Error deleting subscription plan'));
    showToast('Error deleting subscription plan', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const changeEmployerSubscriptionPlan = (payload) => async (dispatch) => {
  dispatch(changeEmployerSubscription());
  dispatch(startLoader());

  try {
    const response = await changeEmployerSubscriptionService(payload);
    if (response.success) {
      dispatch(changeEmployerSubscriptionSuccess(response.data));
      showToast(response.message, 'success')
    } else {
      dispatch(changeEmployerSubscriptionFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(changeEmployerSubscriptionFailure('Error changing subscription plan'));
    showToast('error changing subscription plan', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getCommercialTermsList = (payload) => async (dispatch) => {
  dispatch(getCommercialTerms());
  dispatch(startLoader());

  try {
    const response = await getCommercialTermsService(payload);

    if (response.success) {
      dispatch(getCommercialTermsSuccess(response));
    } else {
      dispatch(getCommercialTermsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getCommercialTermsFailure('Error getting commercial terms list'));
    showToast('Error getting commercial terms list', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const createCommercialTerms = (payload) => async (dispatch) => {
  dispatch(addCommercialTerms());
  dispatch(startLoader());

  try {
    const response = await createCommercialTermsService(payload);
    if (response.success) {
      dispatch(addCommercialTermsSuccess(response.data));
      showToast(response.message, 'success');
      dispatch(getCommercialTermsList());
    } else {
      dispatch(addCommercialTermsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(addCommercialTermsFailure('Error creating commercial terms'));
    showToast('error creating commercial terms', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const updateCommercialTerms = (commercialTermsId, payload) => async (dispatch) => {
  dispatch(editCommercialTerms());
  dispatch(startLoader());

  try {
    const response = await patchCommercialTermsService(commercialTermsId, payload);

    if (response.success) {
      dispatch(editCommercialTermsuccess(response.data));
      showToast(response.message, 'success')
    } else {
      dispatch(editCommercialTermsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(editCommercialTermsFailure('Error editing commercial terms'));
    showToast('Error editing commercial terms', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const deleteCommercialTermsRecord = (commercialTermsId) => async (dispatch) => {
  dispatch(deleteCommercialTerms());
  dispatch(startLoader());

  try {
    const response = await deleteCommercialTermsService(commercialTermsId);
    if (response.success) {
      dispatch(deleteCommercialTermsSuccess(commercialTermsId));
      showToast(response.message, 'success')

    } else {
      dispatch(deleteCommercialTermsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(deleteCommercialTermsFailure('Error deleting commercial terms'));
    showToast('Error deleting commercial terms', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const changeEmployerCommercialTermsPlan = (payload) => async (dispatch) => {
  dispatch(changeEmployerCommercialTerms());
  dispatch(startLoader());

  try {
    const response = await changeEmployerSubscriptionService(payload);
    if (response.success) {
      dispatch(changeEmployerCommercialTermsSuccess(response.data));
      showToast(response.message, 'success')
    } else {
      dispatch(changeEmployerCommercialTermsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(changeEmployerCommercialTermsFailure('Error changing subscription plan'));
    showToast('error changing subscription plan', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardSummaryData = (payload) => async (dispatch) => {
  dispatch(getDashboardSummary());
  dispatch(startLoader());

  try {
    const response = await getDashboardSummaryDataService(payload);
    if (response.success) {
      dispatch(getDashboardSummarySuccess(response.data));
    } else {
      dispatch(getDashboardSummaryFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardSummaryFailure('Error getting dashboard summary'));
    showToast('error getting dashboard summary', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardAppSummaryData = (payload) => async (dispatch) => {
  dispatch(getDashboardAppSummary());
  dispatch(startLoader());

  try {
    const response = await getDashboardAppSummaryDataService(payload);
    if (response.success) {
      dispatch(getDashboardAppSummarySuccess(response.data));
    } else {
      dispatch(getDashboardAppSummaryFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardAppSummaryFailure('Error getting dashboard app summary'));
    showToast('error getting dashboard app summary', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardManagerSummaryData = (payload) => async (dispatch) => {
  dispatch(getDashboardManagerSummary());
  dispatch(startLoader());

  try {
    const response = await getDashboardManagerSummaryDataService(payload);
    if (response.success) {
      dispatch(getDashboardManagerSummarySuccess(response.data));
    } else {
      dispatch(getDashboardManagerSummaryFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardManagerSummaryFailure('Error getting dashboard pipeline summary'));
    showToast('error getting dashboard pipeline summary', 'error');
  } finally {
    dispatch(stopLoader());
  }
};


export const getDashboardPipelineData = (payload) => async (dispatch) => {
  dispatch(getDashboardPipeline());
  dispatch(startLoader());

  try {
    const response = await getDashboardPipelineService(payload);
    if (response.success) {
      dispatch(getDashboardPipelineSuccess(response.data));
    } else {
      dispatch(getDashboardPipelineFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardPipelineFailure('Error getting dashboard pipeline'));
    showToast('error getting dashboard pipeline', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardPendingDetailsCandidatesData = (payload) => async (dispatch) => {
  dispatch(getDashboardPendingDetailsCandidates());
  dispatch(startLoader());

  try {
    const response = await getDashboardPendingDetailsCandidatesService(payload);
    if (response.success) {
      dispatch(getDashboardPendingDetailsCandidatesSuccess(response.data));
    } else {
      dispatch(getDashboardPendingDetailsCandidatesFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardPendingDetailsCandidatesFailure('Error getting dashboard pending details candidates'));
    showToast('error getting dashboard pending details candidates', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getAccountManagerList = (payload) => async (dispatch) => {
  dispatch(getAccountManagers());
  dispatch(startLoader());

  try {
    const response = await getAccountManagersService(payload);
    if (response.success) {
      dispatch(getAccountManagersSuccess(response.data));
    } else {
      dispatch(getAccountManagersFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getAccountManagersFailure('Error getting account managers'));
    showToast('error getting account managers', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardJobApplicationMonthlySummaryData = (payload) => async (dispatch) => {
  dispatch(getDashboardJobApplicationMonthlySummary());
  dispatch(startLoader());

  try {
    const response = await getDashboardJobApplicationMonthlySummaryService(payload);
    if (response.success) {
      dispatch(getDashboardJobApplicationMonthlySummarySuccess(response.data));
    } else {
      dispatch(getDashboardJobApplicationMonthlySummaryFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardJobApplicationMonthlySummaryFailure('Error getting dashboard job application monthly summary'));
    showToast('error getting dashboard job application monthly summary', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardPipelineMonthlySummaryData = (payload) => async (dispatch) => {
  dispatch(getDashboardPipelineMonthlySummary());
  dispatch(startLoader());

  try {
    const response = await getDashboardPipelineMonthlySummaryService(payload);
    if (response.success) {
      dispatch(getDashboardPipelineMonthlySummarySuccess(response.data));
    } else {
      dispatch(getDashboardPipelineMonthlySummaryFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardPipelineMonthlySummaryFailure('Error getting dashboard pipeline monthly summary'));
    showToast('error getting dashboard pipeline monthly summary', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardMoMTrendsData = (payload) => async (dispatch) => {
  dispatch(getDashboardMoMTrends());
  dispatch(startLoader());

  try {
    const response = await getDashboardMoMTrendsService(payload);
    if (response.success) {
      dispatch(getDashboardMoMTrendsSuccess(response.data));
    } else {
      dispatch(getDashboardMoMTrendsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardMoMTrendsFailure('Error getting dashboard mom trends'));
    showToast('error getting dashboard mom trends', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const getDashboardMonthlyTrendsData = (payload) => async (dispatch) => {
  dispatch(getDashboardMonthlyTrends());
  dispatch(startLoader());

  try {
    const response = await getDashboardMonthlyTrendsService(payload);
    if (response.success) {
      dispatch(getDashboardMonthlyTrendsSuccess(response.data));
    } else {
      dispatch(getDashboardMonthlyTrendsFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(getDashboardMonthlyTrendsFailure('Error getting dashboard monthly trends'));
    showToast('error getting dashboard monthly trends', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const setCompanyLevelGoal = (payload) => async (dispatch) => {
  dispatch(setCompanyGoal());
  dispatch(startLoader());

  try {
    const response = await setCompanyGoalService(payload);
    if (response.success) {
      dispatch(setCompanyGoalSuccess(response.data));
      showToast(response.message, 'success');
      dispatch(getDashboardSummaryData());
    } else {
      dispatch(setCompanyGoalFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(setCompanyGoalFailure('Error setting company goal'));
    showToast('error setting company goal', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const updateCompanyLevelGoal = (goalId, payload) => async (dispatch) => {
  dispatch(editCompanyGoal());
  dispatch(startLoader());

  try {
    const response = await updateCompanyGoalService(goalId, payload);
    if (response.success) {
      dispatch(editCompanyGoalSuccess(response.data));
      showToast(response.message, 'success');
      dispatch(getDashboardSummaryData());
    } else {
      dispatch(editCompanyGoalFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(editCompanyGoalFailure('Error updating company goal'));
    showToast('error updating company goal', 'error');
  } finally {
    dispatch(stopLoader());
  }
};

export const setManagerSpecificGoal = (managerId, payload) => async (dispatch) => {
  dispatch(setManagerGoal());
  dispatch(startLoader());

  try {
    const response = await setManagerGoalService(managerId, payload);
    if (response.success) {
      dispatch(setManagerGoalSuccess(response.data));
      showToast(response.message, 'success');
      let aParams = { 'managerId': managerId };
      dispatch(getDashboardManagerSummaryData(aParams));
    } else {
      dispatch(setManagerGoalFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(setManagerGoalFailure('Error setting manager goal'));
    showToast('error setting manager goal', 'error');
  } finally {
    dispatch(stopLoader());
  }
};


export const updateManagerSpecificGoal = (managerId, goalId, payload) => async (dispatch) => {
  dispatch(editManagerGoal());
  dispatch(startLoader());

  try {
    const response = await updateManagerGoalService(managerId, goalId, payload);
    if (response.success) {
      dispatch(editManagerGoalSuccess(response.data));
      showToast(response.message, 'success');
      let aParams = { 'managerId': managerId };
      dispatch(getDashboardManagerSummaryData(aParams));
    } else {
      dispatch(editManagerGoalFailure(response.message));
      showToast(response.message, 'error');
    }
  } catch (error) {
    dispatch(editManagerGoalFailure('Error updating manager goal'));
    showToast('error updating manager goal', 'error');
  } finally {
    dispatch(stopLoader());
  }
};
